<template>
    <div class="modal modal-loading" :class="{'is:on': status}">
        <div class="modal_inner">
            <div class="loading"></div>
            <div class="modal_txt">正在處理</div>
        </div>
        <div class="modal_overlay"></div>
    </div>
</template>

<script>

export default {
    name: 'modal',
    props: {
        msg: String,
        status: Boolean
    },
    watch:{
        status(val){
            console.log(val)
            document.querySelector('body').style.overflow = !val?'visible':'hidden'
        }
    },
    methods: {

    },
}
</script>
<style lang="scss" scoped>
.modal {
    &_inner {
         position: relative;
         z-index: 2;
         border: 1px solid #e6e6e6;
         padding: 20px;
         border-radius: 3px;
         background: white;
         width: 70%;
         max-width: 400px;

        .modal-loading & {
            background: transparent;
            text-align: center;
            border: 0;
        }
     }

    &.is\:on {
        z-index: 1000;
        pointer-events: auto;
        opacity: 1;
    }

    &_overlay {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         z-index: 1;
         background-color: rgba(0, 0, 0, 0.72);
     }

    &_txt {
         text-align: center;
         margin-bottom: 1.5rem;
     }
}

.loading {
    display: inline-block;
    width: 80px;
    height: 80px;

    &:after {
        content: " ";
        display: block;
        width: 64px;
        height: 64px;
        margin: 8px;
        border-radius: 50%;
        border: 6px solid #fff;
        border-color: #fff transparent #fff transparent;
        animation: lds-dual-ring 1.2s linear infinite;
    }
}

@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

</style>
